(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mano-card-motion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mano-card-motion')) {
    customElements.define('mano-card-motion', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const signal = this.abort.signal;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.seen = new WeakSet();
        this.observer = new IntersectionObserver(entries => {
          if (reduced.matches) return;
          for (const entry of entries) {
            if (entry.isIntersecting) { entry.target.classList.add('mano-card-arrive'); this.observer.unobserve(entry.target); }
          }
        }, {threshold:.45});
        const scan = () => {
          document.querySelectorAll('.card-gallery').forEach(card => {
            if(this.seen.has(card)) return;
            this.seen.add(card); card.dataset.manoMotion = '';
            this.observer.observe(card);
          });
        };
        this.mutations = new MutationObserver(scan);
        this.mutations.observe(document.body, {childList:true, subtree:true});
        const cardFor = event => event.target instanceof Element ? event.target.closest('.card-gallery') : null;
        const activate = event => {
          if (reduced.matches) return;
          const card = cardFor(event);
          if (card) { card.classList.remove('mano-card-arrive'); card.classList.add('mano-card-active'); }
        };
        const clear = () => document.querySelectorAll('.mano-card-active').forEach(card => card.classList.remove('mano-card-active'));
        document.addEventListener('pointerdown', activate, {passive:true, signal});
        document.addEventListener('pointerover', event => {if(event.pointerType === 'mouse') activate(event);}, {passive:true, signal});
        document.addEventListener('pointerout', event => {const card=cardFor(event); if(card && !card.contains(event.relatedTarget)) card.classList.remove('mano-card-active');}, {passive:true, signal});
        document.addEventListener('pointerup', clear, {passive:true, signal});
        document.addEventListener('pointercancel', clear, {passive:true, signal});
        document.addEventListener('focusin', activate, {signal});
        document.addEventListener('focusout', clear, {signal});
        document.addEventListener('animationend', event => {if(event.animationName==='mano-card-arrive') cardFor(event)?.classList.remove('mano-card-arrive');}, {signal});
        window.addEventListener('blur', clear, {signal});
        reduced.addEventListener('change', clear, {signal});
        scan();
      }
      disconnectedCallback() {this.abort?.abort(); this.observer?.disconnect(); this.mutations?.disconnect(); document.querySelectorAll('.mano-card-active,.mano-card-arrive').forEach(card=>card.classList.remove('mano-card-active','mano-card-arrive'));}
    });
  }

  } catch(e) { console.error(e); }
})();
})();
